import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { formatAddress } from '@/lib/formatter'
import { User } from '@/redux/user'

export interface NicknameProps {
  user: Pick<User, 'nickname' | 'wallets'> | undefined | null
  className?: string
  maxDisplayLength?: number
}

export default function Nickname({ user, className, maxDisplayLength = 10 }: NicknameProps) {
  if (!user) {
    return <div className={className}>Deleted Account</div>
  }
  if (user?.nickname) {
    const { nickname } = user
    return (
      <div className={className}>
        {maxDisplayLength !== undefined && nickname.length > maxDisplayLength ? (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div>{nickname.slice(0, maxDisplayLength)}...</div>
              </TooltipTrigger>
              <TooltipContent withArrow>
                <p>{nickname}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : nickname}
      </div>
    )
  }
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={className}>{formatAddress()(user?.wallets[0]?.address)}</div>
        </TooltipTrigger>
        <TooltipContent side="bottom" withArrow>
          <p>{user?.wallets[0]?.address}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
